import { isPending } from 'functions';
import React, { useEffect } from 'react';
import ConfirmPopup from '../../ConfirmPopup';

const EgiftStatus = ({ data, quantity, status, handleChangeStatus, handleSubmitChangeGift }) => {
  const { isOpen, isLoading } = status;

  const handleClose = () => {
    handleChangeStatus((prev) => {
      return {
        ...prev,
        isOpen: false,
      };
    });
  };
  const handleSubmit = () => {
    const payload = {
      giftCode: data.giftInfor.code,
      date: new Date().toISOString(),
      description: JSON.stringify({
        fullName: '',
        phone: '',
        shipAddress: '',
        email: '',
        note: '',
      }),
    };
    handleSubmitChangeGift(payload);
  };

  useEffect(() => {
    return () => {
      handleChangeStatus({
        isOpen: false,
        isSuccess: false,
        isFail: false,
        isLoading: false,
        resson: '',
      });
    };
  }, []);
  const processBar = isPending(isLoading);
  return (
    <>
      {processBar}
      {/* confirm */}
      <ConfirmPopup
        isOpen={isOpen}
        handleClose={handleClose}
        handleSubmit={handleSubmit}
        quantity={quantity}
        name={data.giftInfor.name}
        point={data.giftInfor?.requiredCoin}
      />
    </>
  );
};

export default EgiftStatus;
